import { assoc, compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { generalClient } from '../../../../utils/apollo/api'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertScreenView($input: ScreenViewInput) {
    upsertScreenView(input: $input) {
      id
      name
      screen
      filters
    }
  }
`

const cleanRequest = compose(pick(['id', 'name', 'screen', 'filters']), item =>
  assoc('filters', JSON.stringify(item.filters), item)
)

export const useSaveScreenView = () => {
  const { onSave } = useModalData()
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['ScreenViews'], client: generalClient })

  const handleRequest = form => {
    const input = cleanRequest(form)

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        if (onSave) onSave(resp.data?.upsertScreenView)
        closeModal()
      }
    })
  }

  return [handleRequest, state]
}
